import React from 'react'
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Header, Modal, Grid, Checkbox, Message } from 'semantic-ui-react'
import TextEditor from '../../../../common/TextEditor';
import LoadingComponent from '../../../../common/LoadingComponent'

class AddCategoryModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      MakeAnotherActivity: true,
      addCategoryError: null,
      name: '',
      formcyButtonDisabled: false
    }
    this.onSubmitCategory = this.onSubmitCategory.bind(this);
    this.setMakeAnotherActivity = this.setMakeAnotherActivity.bind(this);
    this.updateText = this.updateText.bind(this)
  }

  buttonDisabled = (e, set) => {
    this.setState({ formcyButtonDisabled: set });
  }


  handleClose = () => {
    dispatch.account.setAddCategoryModal(false);
    this.setState({
      MakeAnotherActivity: false,
      addCategoryError: null
    });
  }

  async onSubmitCategory(formData) {
    try {
      let nodeToAdd = {
        name: this.state.name,
        // lastUpdatedBy: this.props.user,
        accountId: this.props.accountId,
        isKb: this.props.levelDepth === "baseCategory" ? true : false,
        isCategory: this.props.levelDepth === "category" ? true : false,
        isSubCategory: this.props.levelDepth === "subCategory" ? true : false,
        parent: this.props.levelDepth === "baseCategory" ? null : this.props.selectedCategory && this.props.selectedCategory._id,
        isPublic: this.props.level === "platform" ? true : false
      }

      if (this.props.organization) {
        nodeToAdd.organizationId = this.props.organization.id
      }

      if (this.props.routeParams) {
        nodeToAdd.routeParams = this.props.routeParams
      }
      await dispatch.categories.createCategory(nodeToAdd);
      this.setState({ addCategoryError: null })
      // await dispatch.categories.getAllCategories({ organizationId: this.props.organizationId })
      setTimeout( async()=>{
        if(this.props.selectedCategory){
          await dispatch.categories.getCategoryById(this.props.selectedCategory._id)
        }
        else{
          await dispatch.categories.getAllCategories({ organizationId: this.props.organizationId })
        }
      }, 100);

      if (!this.state.MakeAnotherActivity) {
        dispatch.account.setAddCategoryModal(false);
      }
      else {
        document.getElementById("AddActivityForm").reset();
      }
    }
    catch (err) {
      // Below changes made for KLM-9071
      if(err.name === "Conflict") {
        let setName = this.props.levelDepth === 'baseCategory' ? "Knowledge Bank" :
                      this.props.levelDepth === 'category' ? "Category" :
                      this.props.levelDepth === 'subCategory' ? "Sub Category" : "Category"
        this.setState({addCategoryError: {
          message: `${setName} with same name already exists.`
        }})
      }
      else {
        this.setState({addCategoryError: err})
      }
      throw err
    }

  }


  setMakeAnotherActivity(event, data) {
    this.setState({ MakeAnotherActivity: data.checked });
  }

  updateText(data, name) {
    if (name.name === "Name") {
      this.setState({ name: name.value.trim() })
    }

    if (name.name === "Name" && name.value.toLowerCase() === "others" && this.props.levelDepth === "category") {
      this.setState({
        addCategoryError: {
          code: 409,
          message: 'The word is reserved for Sub category listing !'
        }
      })
    } else {
      let isSameNameExist = false;
      let sameNameCategories = this.props.allCategories.filter((category) => {
        return category.name.toLowerCase().trim() === name.value.toLowerCase().trim();
      })
      if (sameNameCategories.length > 0) {
        isSameNameExist = true
      }
      if (isSameNameExist) {
        let setName = this.props.levelDepth === 'baseCategory' ? "Knowledge Bank" :
                      this.props.levelDepth === 'category' ? "Category" :
                      this.props.levelDepth === 'subCategory' ? "Sub Category" : "Category"
        this.setState({
          addCategoryError: {
            code: 409,
            message: `${setName} with same name already exists.`
          }
        })
      } else {
        this.setState({
          addCategoryError: null
        })
      }
    }

  }

  setName(name) {
    switch (name) {
      case 'knowledgeBank':
        return "Knowledge bank"
      case 'baseCategory':
        return "Knowledge bank"
      case 'category':
        return "Category"
      case 'subCategory':
        return "Sub Category"
      default:
        return "Sub Category";
    }
  }

  render() {
    let loading = <LoadingComponent active={this.props.loading} message="Adding..." />

    let header = <Header content={`Add ${this.setName(this.props.levelDepth)}`} />

    let errorMsg = this.state.addCategoryError ?
      <span className='clr-red'>
        {this.state.addCategoryError.message}
      </span>
      : null

    let createMessage = "Create Another " + this.setName(this.props.levelDepth)

    return (
      <Modal
        open={this.props.isAddCategoryModalOpen}
        onClose={this.handleClose}
        size='tiny'
        className="basicModal"
        closeOnEscape={true}
        closeOnDimmerClick={false}
        closeIcon
      >

        {loading}
        <Form noValidate
          className="formcyForm"
          ref={ref => this.form = ref}
          id="AddActivityForm"
          onValidSubmit={(event) => { this.onSubmitCategory(event) }}
          onValid={(e) => this.buttonDisabled(e, true)}
          onInvalid={(e) => this.buttonDisabled(e, false)}
        >
          <Modal.Content style={{ padding: "20px 20px 0 20px" }}>
            {header}
            <Form.Input
              name="Name"
              label="Name"
              value={this.state.name}
              onChange={this.updateText}
              required={true}
              autoFocus
            />
            {errorMsg}
          </Modal.Content>
          <Modal.Actions className="actionInFormcy">
            <div style={{ textAlign: 'left' }}><br />

              <Checkbox
                label={createMessage}
                className='diamond-location' checked={this.state.MakeAnotherActivity}
                onChange={(event, data) => this.setMakeAnotherActivity(event, data)}
                className="float-left" />
            </div>
            <Button
              className="button-submit float-right"
              id='addbtn'
              type="submit"
              disabled={this.state.addCategoryError || !this.state.formcyButtonDisabled}> Add
             </Button>
            <Button
              id='cancelBtn'
              className="button-cancel"
              onClick={this.handleClose}> Cancel
             </Button>
          </Modal.Actions>
        </Form>
      </Modal>
    )
  }
}

export default AddCategoryModal